/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrowCircleRight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10zm0-2c4.412 0 8-3.59 8-8s-3.588-8-8-8-8 3.59-8 8 3.588 8 8 8zm-.293-2.293-1.414-1.414L13.586 13H7v-2h6.586l-3.293-3.293 1.414-1.414L17.414 12z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArrowCircleRight as ArrowCircleRight };
